"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (prevFn, nextFn) {
    return function () {
      return nextFn(prevFn.apply(void 0, arguments));
    };
  }, function (value) {
    return value;
  });
};

exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wdXJlLWZ1bmN0aW9ucy9waXBlLnRzIl0sIm5hbWVzIjpbImZ1bmNzIiwicmVkdWNlIiwicHJldkZuIiwibmV4dEZuIiwidmFsdWUiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7ZUFBZTtBQUFBLG9DQUFJQSxLQUFKO0FBQUlBLElBQUFBLEtBQUo7QUFBQTs7QUFBQSxTQUNiQSxLQUFLLENBQUNDLE1BQU4sQ0FBYSxVQUFDQyxNQUFELEVBQVNDLE1BQVQ7QUFBQSxXQUNYO0FBQUEsYUFBYUEsTUFBTSxDQUFDRCxNQUFNLE1BQU4sbUJBQUQsQ0FBbkI7QUFBQSxLQURXO0FBQUEsR0FBYixFQUVFLFVBQUFFLEtBQUs7QUFBQSxXQUFJQSxLQUFKO0FBQUEsR0FGUCxDQURhO0FBQUEsQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0ICguLi5mdW5jcykgPT5cbiAgZnVuY3MucmVkdWNlKChwcmV2Rm4sIG5leHRGbikgPT5cbiAgICAoLi4uYXJncykgPT4gbmV4dEZuKHByZXZGbiguLi5hcmdzKSksXG4gICAgdmFsdWUgPT4gdmFsdWVcbiAgKTsiXX0=